import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight, GraduationCap, Users } from "lucide-react";
import { enrollmentDeadline, courses } from "../data/mock";
import { Badge } from "./ui/badge";

const Countdown = () => {
  const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  // Featured course: ASACOM
  const featured = courses.find(c => c.slug === "corso-asacom") || courses[0];

  useEffect(() => {
    const target = new Date(enrollmentDeadline).getTime();
    const update = () => {
      const now = Date.now();
      const diff = Math.max(0, target - now);
      setTime({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60)
      });
    };
    update();
    const t = setInterval(update, 1000);
    return () => clearInterval(t);
  }, []);

  const boxes = [
    { label: "Giorni", value: time.days },
    { label: "Ore", value: time.hours },
    { label: "Minuti", value: time.minutes },
    { label: "Secondi", value: time.seconds }
  ];

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-xl border border-emerald-100">
      {/* Featured Course Header */}
      <Link to={`/corsi/${featured.slug}`} className="block relative aspect-[16/9] overflow-hidden bg-emerald-50 group">
        <img
          src={featured.image}
          alt={featured.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/85 via-brand-dark/30 to-transparent"></div>

        <Badge className="absolute top-3 left-3 bg-white text-brand hover:bg-white font-semibold text-xs">
          Corso in evidenza · {featured.tag}
        </Badge>

        <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
          <p className="text-xs uppercase tracking-wider text-emerald-200 mb-1">{featured.fullTitle}</p>
          <h3 className="font-display text-2xl font-bold leading-tight mb-2">{featured.title}</h3>
          <div className="flex items-center gap-4 text-xs">
            <span className="flex items-center gap-1"><GraduationCap className="w-3.5 h-3.5" /> {featured.duration}</span>
            <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {featured.practice}</span>
          </div>
        </div>
      </Link>

      {/* Countdown */}
      <div className="p-5">
        <div className="flex items-center gap-2 justify-center mb-3 text-brand">
          <Clock className="w-4 h-4" />
          <span className="text-xs font-semibold uppercase tracking-wider">Iscrizioni in chiusura</span>
        </div>

        <div className="grid grid-cols-4 gap-2 mb-4">
          {boxes.map((b) => (
            <div key={b.label} className="text-center">
              <div className="bg-brand-light rounded-xl py-3">
                <div className="font-display text-2xl md:text-3xl font-bold text-brand tabular-nums">
                  {String(b.value).padStart(2, "0")}
                </div>
              </div>
              <div className="text-[10px] md:text-xs text-brand-dark/60 mt-1 font-medium uppercase tracking-wide">{b.label}</div>
            </div>
          ))}
        </div>

        <Link
          to={`/corsi/${featured.slug}`}
          className="w-full inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-dark text-white rounded-full h-11 font-semibold text-sm transition-colors"
        >
          Scopri il corso {featured.title.replace("Corso ", "")} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};

export default Countdown;
